import AppLogo from "@/assets/images/delvium-logo.png";
import delviumLogo from "@/assets/images/logo.png";
import  bgImg  from "@/assets/images/home_screen_login.png" ;
import  Logo1 from "@/assets/images/delvium_logo_login.png" ;

export { AppLogo, delviumLogo, bgImg, Logo1};
